import { useState, useEffect } from "react";
import MainCarousel from "../../components/Landing/MainCarousel";
import PatientCard from "../../components/PaitientCard/PatientCard";
import styles from "./PatientInfo.module.scss";
import styled from "styled-components";


const HealthySleepBlog = ({ type,setSearchText }) => {
  

  return (
    <div className="row">
          {/* <!-- Post Item #1  --> */}
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="post-item">
              <div className="post__img">
                <a href="blog-single-post.html">
                  <img src="../../assets/images/blog/sleep.jpg" alt="post image" loading="lazy"  width="98%" height="500px"/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="#">Diabetic Diet</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Jan 20, 2022</span>
                  <a className="post__meta-author" href="#">A Sengupta</a>
                </div>
                <h4 className="post__title">Healthy Sleeping Habits</h4>

                <p className="post__desc">Not sleeping well? 
                Feel tired throughout the day?
                As we become increasingly busy with our lives during the day, it becomes equally important to get a good sleep at night. 
                However, did you know, there are quite some things we all must do to ensure quality sleep. Here is a list of things that could help in improving your sleep health:

                  </p>

                <h4 className="post__title" style={{marginBottom: "10px !important",fontSize:"30px"}}>1. Create Differences in Illumination</h4>
                •	Our brain detects differences in illumination to sense day and night<br/><br/>
                <h2 className="post__title" style={{marginBottom: "10px !important"}}>Ideal Practices</h2>
                  <span className="post__desc page-margin">
                  1.	Get outside into sunlight in the day. <br/>
                 <span style={{marginLeft:"50px"}}> o	NO OTHER SOURCE of light has even comparable luminous flux compared to sunlight, hence sunlight in the day is ABSOLUTELY ESSENTIAL </span><br/>
                 <span style={{marginLeft:"50px"}}>     o	Not practical on rainy days or during winter</span><br/>
                 <span style={{marginLeft:"50px"}}>      o	Get outside and take exposure to sunlight no matter what the weather is, or how well lit the surroundings are. The ambient lighting is always enough for the brain to stay healthy.</span><br/>
                  2.	Do NOT use electronics for at least 1.5 hours before going to bed. <br/><br/>

                  </span>
                  <h2 className="post__title" style={{marginBottom: "10px !important"}}>Things that could be done</h2>
                  <span className="post__desc page-margin">
                  •	1 hour before going to bed: <br/>
                 <span style={{marginLeft:"50px"}}> •Read books </span><br/>
                 <span style={{marginLeft:"50px"}}>     •	Do chores</span><br/>
                 <span style={{marginLeft:"50px"}}>     •	Do chores</span><br/><br/><br/>
                 

                  </span>

                  <h4 className="post__title" style={{marginBottom: "10px !important",fontSize:"30px"}}>2. EXERCISE after waking in the morning, ASAP</h4>

                  <span className="post__desc">
                  •	Exercise in the day improves the hormonal and neuronal cycles in sleep.<br/>
                  •	Cortisol levels are high right after waking up. <br/>
                  <span style={{marginLeft:"50px"}}>o	Helps immensely in increasing the benefits of exercise (specifically, improves calorie burning)</span><br/>
                  <span style={{marginLeft:"50px"}}>o	High carbohydrate meals must not be consumed</span><br/><br/>

                  </span>

                  <h2 className="post__title" style={{marginBottom: "10px !important"}}>Ideal Practices</h2>
                  <span className="post__desc page-margin">
                  •	Proper Workout in the day  <br/>
                 <span style={{marginLeft:"50px"}}> You could even do small cardio, 20 secs of workout followed by 10 secs of rest for 5 minutes, or even run up and down stairs: 20 secs run, 10 secs pause for 5 mins </span><br/>
                  <br/><br/>

                  </span>
                  <h4 className="post__title" style={{marginBottom: "10px !important",fontSize:"30px"}}>3. Make Sleep a PRIORITY</h4>

                  <span className="post__desc page-margin" >
                  •	Be CONSCIOUS and AWARE of your sleep<br/>
                  •	Often people are too busy to sleep. This hurts productivity and health on the long run.<br/>
                  •	Positivity and Positive thoughts and activities are good but jumping from one thing to the next very often doesn't help on the long run.<br/>
                  •	Social networks (including people, not just media) must be kept manageable.
                  <br/><br/><br/>
                  </span>

                <h4 className="post__title" style={{marginBottom: "10px !important",fontSize:"30px"}}>4. STOP EATING at least 3 hours before bedtime</h4>
                •	3-hour window between Dinner and bedtime prevents Alzheimer's disease<br/>
                <span style={{marginLeft:"50px"}}>o	Resolves brain inflammation</span><br/>
                <span style={{marginLeft:"50px"}}>o	Autophagy is crucial to cleaning the plaque which eventually causes Parkinson's and Alzheimer's. When the body is well-fed, autophagy doesn't occur.</span><br/><br/>
                
                <h2 className="post__title" style={{marginBottom: "10px !important"}}> Ideal Practice:</h2>
                •	Don't eat Anything for 3 hours prior to going to bed. <br/>
                <span style={{marginLeft:"50px"}}>o	This can easily be followed.</span><br/><br/>
                
                <h4 className="post__title" style={{marginBottom: "10px !important",fontSize:"30px"}}>5. STOP STRESSING</h4>
                <span className="post__desc page-margin" >
                •	During sleep, the glymphatic system circulates CSF and cleans the brain<br/>
                •	Bad sleep causes accumulation of harmful metabolites. <br/>
                <span style={{marginLeft:"50px"}}>o	Even one night of bad sleep leads to measurable changes in Amyloid proteins.</span><br/>
                •	Sleep regulates the Endocrine system and hence behavior <br/>
                <span style={{marginLeft:"50px"}}>o	Sleep generates motivation</span><br/>
                <span style={{marginLeft:"50px"}}>o	Sleep neutralizes emotional disturbances</span><br/>
                •	Stress can be of two types: Acute and Chronic <br/>
                <span style={{marginLeft:"50px"}}>o	Acute Stress: Beneficial</span><br/>
                <span style={{marginLeft:"50px"}}>o	Chronic Stress: </span><br/>
                <span style={{marginLeft:"100px"}}>	One in six adults today use psychoactive medication, often under self-medication</span><br/>
                <span style={{marginLeft:"100px"}}>	Causes sleep loss and hence adversely affects all aspects of stress</span><br/>
                <span style={{marginLeft:"100px"}}>	Consuming excess calories in chronic stress intensifies the harmful effects of excessive calories.</span><br/>
                <h2 className="post__title" style={{marginBottom: "10px !important"}}>Best Practices</h2>
                <span style={{marginLeft:"50px"}}>•	Destress </span><br/>
                <span style={{marginLeft:"100px"}}>o	Meditate </span><br/>
                <span style={{marginLeft:"100px"}}>o	Do not consume excess calories </span><br/>
                </span><br/><br/><br/>
                <h4 className="post__title" style={{marginBottom: "10px !important",fontSize:"30px"}}>6. BLOCK MORE than just Blue Light</h4>
                <span className="post__desc page-margin" >
                •	4 types of light have a role to play in sleep. Two of them:<br/>
                <span style={{marginLeft:"50px"}}> o	Blue light: Most focused on but blocking this only is NOT ENOUGH. </span><br/>
                <span style={{marginLeft:"50px"}}>o	Red light: Has immense benefits on the body. </span><br/>
                </span><br/><br/>
                <h2 className="post__title" style={{marginBottom: "10px !important"}}>Best Practices</h2>
                <span style={{marginLeft:"50px"}}> •	Stay away from screens for at least an hour before bed.</span><br/>
                <span style={{marginLeft:"50px"}}> •	Get exposure to sunrise and sunset as frequently as possible</span><br/><br/><br/><br/><br/>

                <span style={{fontStyle:"italic",textAlign:"center"}}>  Based on a YouTube video posted by Reliable and Popular influencer, Tom Bilyeu on his channel</span>

              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
          </div>
  );
};

const Card = styled.div`
  background-color: white;
  border: 2px solid #d5d5d5;
  padding: 0.5rem;
  border-radius: 10px;
  flex-grow: 1;
  flex-basis: 46%;
  h6 {
    text-align: center;
    font-size: 1rem;
    margin-block: 3%;
  }
  ul {
    padding-left: 10%;
  }
  a {
    padding-left: 10%;
    color: #651fff !important;
  }
`;

export default HealthySleepBlog;
